<template>
  <div id="publishing-journal-website-publisher-policy">
    <div class="mar-b-10"
         v-for="item in dataSource"
         :key="item.id||item.name">
      <div class="ipub-p1 mar-b-10 content-bg part">
        {{item.name}}
        <a @click="add(item)"
           class="link-color mar-l-10 ipub-p2 fw-bd"
           v-if="item.code==='about'&&user.codeList&&user.codeList.includes('WEBSITE.JOURNAL_WEBSITE.POLICY.ADD')">
          <ipub-icon type="iconAdd" />
          Add Sub Journal Menu
        </a>
        <a @click="edit(item)"
           class="link-color mar-l-10 ipub-p2"
           v-if="item.code==='editorial_office'">
          <ipub-icon type="iconEdit" />
          Edit
        </a>
      </div>
      <ipub-tree class="ipub-tree-item__children"
                 @edit="edit"
                 @delete="del"
                 @add="add"
                 @drag="setSort"
                 :deep="1"
                 :tree="item.children" />

    </div>
    <Add ref="publisher-policy-add"
         :tree="dataSource"
         :isVisable="isVisable"
         @confirm="confirm"
         @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
